import { StyledActionButton } from "@/components/shared/StyledActionButton";
import { Box, Center, Stack, Text, Title } from "@mantine/core";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";

export const PaymentFailPage = () => {
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");
  const message = searchParams.get("message");
  const paymentId = searchParams.get("paymentId");

  useEffect(() => {
    // Clean up session storage on payment failure
    sessionStorage.removeItem("pendingReservation");
  }, []);

  return (
    <Stack p="md" h="100%">
      <Title order={3} ta="center" c="red">
        결제에 실패했습니다
      </Title>
      <Text c="dimmed" size="sm" ta="center" mt="sm">
        문제가 발생하여 결제를 완료할 수 없었습니다.
      </Text>
      <Box
        mt="lg"
        p="md"
        style={{
          backgroundColor: "var(--mantine-color-gray-0)",
          borderRadius: "var(--mantine-radius-sm)",
        }}
      >
        <Text c="black">
          <strong>오류 코드:</strong> {code}
        </Text>
        <Text c="black">
          <strong>오류 메시지:</strong> {message}
        </Text>
        <Text c="black">
          <strong>결제 ID:</strong> {paymentId}
        </Text>
      </Box>
      <Stack flex={1} justify="flex-end">
        <Center>
          <StyledActionButton
            w="100%"
            mb="lg"
            size="lg"
            component={Link}
            to="/home"
            fullWidth
            mt="xl"
          >
            홈으로 돌아가기
          </StyledActionButton>
        </Center>
      </Stack>
    </Stack>
  );
};
